import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Là hình thức sử dụng chuyển các loại tiền mã hoá, giao dịch tự động cập nhật từ phía mạng chuyển khoản và cộng tiền trực tiếp vào tài khoản của bạn với chi phí CỰC RẺ"),
  /*#__PURE__*/_createElementVNode("li", null, "Bạn chỉ cần có một tài khoản của các sàn Tiền điện tử (VD: Binance.com, Remitano.com) và sở hữu một trong số các đồng tiền trên \"Thông tin chuyển khoản\" là có thể sử dụng dịch vụ"),
  /*#__PURE__*/_createElementVNode("li", null, "Tài khoản sẽ được tự động cộng tiền ngay sau khi ví tiền mã hoá của chúng tôi nhận được thông tin thanh toán thành công")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Số tiền nhận được sẽ được quy đổi theo giá bán ra của loại tiền đó tại thời điểm check tương ứng trên sàn Binance.com"),
  /*#__PURE__*/_createElementVNode("li", null, "Mọi chi tiết xin liên hệ fanpage để được hỗ trợ")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SyncOutlined = _resolveComponent("SyncOutlined")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.chargeViaCryptCoin')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.isLoading,
        active: ""
      }, {
        default: _withCtx(() => [
          (_ctx.transPrefix)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                false
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      message: "Mã Giao Dịch lần này",
                      type: "info",
                      class: "mb-20"
                    }, {
                      description: _withCtx(() => [
                        _createVNode(_component_a_tag, { color: "purple" }, {
                          icon: _withCtx(() => [
                            _createVNode(_component_SyncOutlined, {
                              style: {"font-size":"20px","vertical-align":"baseline"},
                              spin: ""
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_typography_title, {
                              level: 2,
                              style: {"margin":"0","display":"inline-block"},
                              copyable: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("X" + _toDisplayString(_ctx.transPrefix) + "X" + _toDisplayString(_ctx.transId) + "X", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_collapse, {
                  activeKey: _ctx.bankAccsActiveKeys,
                  "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bankAccsActiveKeys) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_collapse_panel, {
                      key: "list",
                      header: "Thông tin chuyển khoản"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          dataSource: _ctx.bankAccs,
                          columns: _ctx.bankAccsCols,
                          pagination: false,
                          loading: _ctx.isFetchingBankAccs,
                          class: "mb-20"
                        }, {
                          bodyCell: _withCtx(({ column, text }) => [
                            (column.dataIndex === 'address')
                              ? (_openBlock(), _createBlock(_component_a_typography_title, {
                                  key: 0,
                                  level: 3,
                                  copyable: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(text), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["dataSource", "columns", "loading"]),
                        _createVNode(_component_a_button, {
                          type: "primary",
                          size: "large",
                          block: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fetchBackAccs())),
                          loading: _ctx.isFetchingBankAccs
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Nhận thông tin Ví Tiền mã hoá để chuyển khoản")
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_collapse_panel, {
                      key: "help",
                      header: "Hướng dẫn nạp"
                    }),
                    _createVNode(_component_a_collapse_panel, {
                      key: "info",
                      header: "Giới thiệu & Lưu ý"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_typography_paragraph, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_typography_title, { level: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Giới thiệu nạp thông qua Tiền mã hoá / Cryptocurrencies")
                              ]),
                              _: 1
                            }),
                            _hoisted_2,
                            _createVNode(_component_a_typography_title, { level: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Quý khách hàng lưu ý")
                              ]),
                              _: 1
                            }),
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["activeKey"])
              ]))
            : (_openBlock(), _createBlock(_component_a_alert, {
                key: 1,
                message: "Xảy ra lỗi, vui lòng thử lại",
                type: "warning"
              }, {
                description: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fetchPaymentInfo()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Thử lại")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["loading"]),
      (false && _ctx.hasManagerPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_table, {
              dataSource: _ctx.dataSource,
              columns: _ctx.columns,
              pagination: _ctx.pagination,
              loading: _ctx.isLoadingTable,
              scroll: {x: '100%'}
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.key === 'action')
                  ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                      default: _withCtx(() => [
                        (record.status === _ctx.PaymentStatus.NOT_PAID)
                          ? (_openBlock(), _createBlock(_component_a_tooltip, {
                              key: 0,
                              title: "Huỷ giao dịch"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  danger: "",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.deletePaymentConfirm(record))
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_DeleteOutlined)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "pagination", "loading"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}